import type {ErrorMessage} from 'angular-error-repository';

export const RequiredError: ErrorMessage = () => {
    return 'Error.Please fill in this field';
};
